import React from "react";
import StaticPageTemplate from "../StaticPage/StaticPageTemplate";

const SelfStudy = () => {
  return (
    <StaticPageTemplate
      slug="self-study"
      defaultTitle="Self Study"
      defaultFeatureImage="https://storage.googleapis.com/road-to-fe/uploads/1741110097103-a07d0770-80d0-495b-b90a-17c1ca349875-selfStudy.webp"
    />
  );
};

export default SelfStudy;
